import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"10px","color":"white"} }, "Режим слайдов", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_on_boarding = _resolveComponent("on-boarding")!

  return (_ctx.$route.meta.slideMode)
    ? (_openBlock(), _createBlock(_component_on_boarding, {
        key: 0,
        "model-value": _ctx.sliderHint,
        onClose: _ctx.close
      }, {
        reference: _withCtx(() => [
          _createElementVNode("div", null, [
            _hoisted_1,
            _createVNode(_component_el_switch, {
              class: "header__switch",
              "model-value": _ctx.isSlideMode,
              onChange: _ctx.toggle
            }, null, 8, ["model-value", "onChange"])
          ])
        ]),
        default: _withCtx(() => [
          _createTextVNode(" Отчёты можно просматривать не только в бумажном виде но и в специально-подготовленном для демонстрации слайд-режиме. ")
        ]),
        _: 1
      }, 8, ["model-value", "onClose"]))
    : _createCommentVNode("", true)
}